import { GetByIdResource, createApiResource } from '../apiResourceFactory';
import { API } from '../apiService';
import { EmployeeDetailDTO } from '../apiTypes.shim';

interface EmployeeResource extends GetByIdResource<EmployeeDetailDTO> {}

export const createEmployeeResource = (): EmployeeResource => {
  const employeeResourceUri = `employee`;

  const { useGetById, getById, getByIdQueryKey } = createApiResource(API, employeeResourceUri);

  return {
    useGetById,
    getById,
    getByIdQueryKey
  };
};
